// This component is designed to display loads related to a specific service provider in a modal format,
import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { IsoToDateWithoutTime } from "../../../CommonFunction/IsoDateTime";
import { LoadTable } from "../../Components";
import BidDetails from "../../Components/FormComponents/AddLoad/Bidding";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
// This query retreives all loads related to a given sp ID, including details like the load's unique ID, cities (from and to ), loading data, and target price.
const Get_All_SP_RELATED_LOADS = gql`
  query GetLoadsAsPerSPIdPopulateLoadID($SP_ID: ID) {
    GetLoadsAsPerSPIdPopulateLoadID(SP_ID: $SP_ID) {
      _id
      Unique_Id
      Load_Id {
        _id
        Unique_Id
        From_City
        To_City
        Loading_Date
        Load_Manager
        Target_Price
      }
      createdAt
    }
  }
`;
//
const SPRelatedLoads = ({ fielddata, show, RespId, totalWeight, LoadId, setShowModal, TypeOfPortal }) => {
  // useState hooks used for managing component states like modal visibility (`openItems`), related loads data (`relatedLoads`) and bid modal visibility (`showBidModal`)
  const [openItems, setOpenItems] = useState(show);
  const [relatedLoad, setRelatedLoads] = useState([]);
  const [showBidModal, setShowBidModal] = useState(false);
  const dispatch = useDispatch();
  // useQuery Hook executes query with the RespId variable to fetch loads related to the specified SP. It uses a `network-only` fetch policy to ensure fresh data is fetched from the server.
  const { data, refetch } = useQuery(Get_All_SP_RELATED_LOADS, {
    variables: {
      SP_ID: RespId,
    },
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  let handleBidModalfuc = () => {
    setShowBidModal(true);
  };

  const Closeformfunction2 = () => {
    setShowModal();
    setOpenItems(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  useEffect(() => {
    if (data) {
      let modifiedData = data.GetLoadsAsPerSPIdPopulateLoadID.map((e) => {
        let obj = {
          Load_Id: e.Load_Id.Unique_Id,
          From_City: e.Load_Id.From_City,
          To_City: e.Load_Id.To_City,
          Loading_Date: IsoToDateWithoutTime(e.Load_Id.Loading_Date),
          Target_Price: e.Load_Id.Target_Price,
          Bid_Now: (
            <a href="#" style={{ color: "blue", textDecoration: "none" }} onClick={() => handleBidModalfuc()}>
              {" "}
              Bid Now
            </a>
          ),
        };
        return obj;
      });
      setRelatedLoads(modifiedData);
    }
  }, [data]);

  let submit = () => {};

  return (
    <Reactportal open={openItems} onClose={Closeformfunction2} TypeOfPortal={"Related Loads"}>
      <div className="mainResultDetailsdiv">
        <div className=" SearchSPMaindiv">
          <div className="SearchSPData">
            {!relatedLoad?.length ? (
              <p style={{ textAlign: "center" }}>Data not Available</p>
            ) : (
              <LoadTable data={relatedLoad} loading={false} error={null} title={"SpRelated Loads"} />
            )}
          </div>
        </div>

        {showBidModal && (
          <BidDetails
            show={showBidModal}
            LoadId={LoadId}
            setShowModal={() => setShowBidModal(!showBidModal)}
            fielddata={""}
            totalWeight={undefined}
            TypeOfPortal={undefined}
          />
        )}

        {/* {showWarningModal && (
          <WarningModal
            show={showWarningModal}
            getAllSP={() => handleRefetchAllSP()}
            loading={researchSPloading}
            setShowModal={() => setShowWarningModal(!showWarningModal)}
          />
        )}  */}
      </div>

      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        submitType={""}
        SaveAndClose={""}
        handleformclose={() => {
          Closeformfunction2();
          setOpenItems(false);
        }}
      />
    </Reactportal>
  );
};

export default SPRelatedLoads;
